interface Resource {
  endpoint: string;
  scopes: string[];
}

export interface ProtectedResource {
  default: Resource;
}
